<script setup>
  import { ref, computed, onMounted, watchEffect } from 'vue';

  import { useAdStore } from "@/stores/AdStore.js";
  import { useIntersectionObserver } from '@vueuse/core';

  const id = defineModel('id');

  const props = defineProps({
    type: {
      type: String,
      required: true
    }
  })

  const adStore = useAdStore();

  const adId = ref(adStore.registerAdSlot(props.type));
  const target = ref();

  const adStyles = computed(() => `--ad-width: ${adStore.adWidth(props.type)}px; --ad-height: ${adStore.adHeight(props.type)}px`);

  
  onMounted(() => {
    adStore.defineAdSlot({id: adId.value, position: props.type});
    id.value = adId.value;
  });

  const { stop } = useIntersectionObserver(
    target,
    ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        adStore.loadAd(adId.value);
      }

      if (isIntersecting) stop();
    },
    {
      rootMargin: '300px'
    }
  )
  </script>

<template>
  <div
    class="jwx-banner-ad-container"
    :width="`${adStore.adWidth(props.type)}px`"
    >
    <div
      ref="target"
      :id="adId"
      class="jwx-banner-ad"
      :style="adStyles"
      :width="`${adStore.adWidth(props.type)}px`"
      :height="`${adStore.adHeight(props.type)}px`"
    ></div>
  </div>
</template>